// src/components/Landing.jsx
import React, { useRef, useEffect } from "react";
import Rsvp from "./rsvp/rsvp";
import Header from "./Header";
import Timeline from "./Timeline";
import CountDown from "./CountDown";
import Navbar from "./Navbar";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function Landing({ isArabic, setIsArabic, inviteeData }) {
  const headerRef = useRef(null);
  const countdownRef = useRef(null);
  const timelineRef = useRef(null);
  const rsvpRef = useRef(null);

  useEffect(() => {
    // Animation for each section on page load
    [headerRef, countdownRef, timelineRef, rsvpRef].forEach((sectionRef) => {
      gsap.fromTo(
        sectionRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 3,
          ease: 'power2.out',
        }
      );
    });
  }, []);
  

  return (
    <div className=" h-full overflow-y-scroll flex flex-col justify-between">
      <div className="fixed top-0 w-full p-4 z-40">
        <Navbar setIsArabic={setIsArabic} isArabic={isArabic} />
      </div>
      <div className="flex flex-col w-full gap-3">
        <div ref={headerRef}>
          <Header isArabic={isArabic} inviteeData={inviteeData} />
        </div>
        <div ref={countdownRef}>
          <CountDown isArabic={isArabic} />
        </div>
      </div>
      {/* <div ref={timelineRef}>
        <Timeline isArabic={isArabic} />
      </div> */}
        <div className="" ref={rsvpRef}>
          <Rsvp inviteeData={inviteeData} setInviteeData={() => {}} isArabic={isArabic} />
        
      </div>
        <div className='w-full  bg-text text-center text-white py-1 mt-4 md:py-5 justify-self-end'>
          Powered by <a target="_blank" rel="noopener noreferrer" href={isArabic ? 'https://flokisoft.com/products?lang=ar&id=1' : 'https://flokisoft.com/products?lang=en&id=1'} className='text-textgold font-bold underline'>FlokiEvents</a>
        </div>
    </div>
  );
}

export default Landing;
